import * as React from "react";
import * as firebase from "firebase/app";
import * as firebaseui from "firebaseui";
import "firebaseui/dist/firebaseui.css";
import { observer } from "mobx-react";

export const Login: React.FC = observer(() => {
  React.useEffect(() => {
    // FirebaseUI config.
    const uiConfig = {
      signInSuccessUrl: "/start",
      signInOptions: [firebase.auth.EmailAuthProvider.PROVIDER_ID],
    };

    const ui = new firebaseui.auth.AuthUI(firebase.auth());
    ui.start("#auth-container", uiConfig);

    return () => { ui.delete() }
  }, []);

  return <div id="auth-container" />;
});
